/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ro-member-number .ngx-input-tag{border-radius:2px}  .ro-member-number .ngx-input-tag__btn{font-size:24px!important}  .ro-member-number input{border:0!important;padding:0!important;background:#fff!important;transition:none!important}  .ro-member-number input:active,   .ro-member-number input:focus{background:#fff!important}"];
export { styles as styles };
